import type React from 'react'

import { useCallback } from 'react'

import { BodyMediumSubtext } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

import { Tabs as BaseTabs, TabsList, TabsTrigger } from './base'

export interface Props extends React.PropsWithChildren {
  tabs: string[]
  defaultTab?: string
  rightSlot?: React.ReactNode
  onTabChange?: (value: string) => void
  value?: string
  baseTabsClassName?: string
  tabListClassName?: string
  tabCounts?: {
    [key: string]: number
  }
  children?: React.ReactNode
}

/**
 * @deprecated Use `Tab` from `@moment/design-system-ui/tab` instead.
 */
// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function Tabs({
  tabs,
  defaultTab,
  rightSlot,
  onTabChange,
  value,
  tabListClassName = '',
  baseTabsClassName = '',
  tabCounts,
  children,
  ...rest
}: Props) {
  const getTabCount = useCallback(
    (tab: string) => {
      if (!tabCounts) {
        return null
      }
      return tabCounts[tab]
    },
    [tabCounts],
  )
  return (
    <BaseTabs
      {...{
        defaultValue: defaultTab,
        onTabChange,
        className: baseTabsClassName,
        ...(value !== undefined ? { value } : {}),
        ...rest,
      }}
    >
      <TabsList
        className={cn('flex items-center justify-between bg-background')}
      >
        <div className={`flex ${tabListClassName}`}>
          {tabs.map((tab, index) => (
            <TabsTrigger key={index} value={tab}>
              <div>
                <BodyMediumSubtext>
                  {`${tab} ${getTabCount(tab) !== null ? `${getTabCount(tab)}` : ''}`}
                </BodyMediumSubtext>
              </div>
            </TabsTrigger>
          ))}
        </div>
        {rightSlot && <div className={cn('ml-auto')}>{rightSlot}</div>}
      </TabsList>
      {children}
    </BaseTabs>
  )
}
